import {GetSafeValue} from '../utils/get-safe-value';
import {StringFieldUtil} from '../utils/string-field-util';

export class SocialMediaUrl {

  private _androidUrl: string;
  private _iosUrl: string;
  private _webUrl: string;


  constructor() {

  }

  clone(data: SocialMediaUrl ){
    this.androidUrl =  data.androidUrl;
    this.iosUrl = data.iosUrl;
    this.webUrl = data.webUrl;
  }

  fromJson(data: SocialMediaUrl){
    this.androidUrl = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.androidUrl], null);
    this.iosUrl =  GetSafeValue.getSafeValueAsString(data[StringFieldUtil.iosUrl], null);
    this.webUrl = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.webUrl], null);
  }

  get androidUrl(): string {
    return this._androidUrl;
  }

  set androidUrl(value: string) {
    this._androidUrl = value;
  }

  get iosUrl(): string {
    return this._iosUrl;
  }

  set iosUrl(value: string) {
    this._iosUrl = value;
  }

  get webUrl(): string {
    return this._webUrl;
  }

  set webUrl(value: string) {
    this._webUrl = value;
  }

  toMap() {
    return {
      'androidUrl': !this.androidUrl ? null : this.androidUrl,
      'iosUrl': !this.iosUrl ? null : this.iosUrl,
      'webUrl': !this.webUrl ? null : this.webUrl
    };
  }
}
